import React, { useRef, createContext, useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import Sidebar from '../../../components/Sidebar/Sidebar';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import { post } from '../../../Script/Session.js';
import { Token } from '../../../Script/Session.js';
import Group from './Components/Group.jsx';
import { grey } from '@mui/material/colors';
import CreateButton from '../../../components/buttons/createButton/CreateButton.jsx';
import CreateForm from './Components/CreateForm/CreateForm.jsx';
import UserBar from '../../../components/UserBar/Userbar.jsx';
import Stylebutton from '../../../components/buttons/stylebutton/Stylebutton.jsx';
const GruppenVerwaltung = () => {
    const navigate = useNavigate();
    const [data, setdata] = useState("{}");
    const [dis, setdis] = useState("none");
    const [value, setval] = useState("3.8%");
    function enter() {
        setval("12.8%");
    }
    function leave() {
        setval("3.8%");
    }
    function create() {
        setdis("block");
    }
    function del() {
        if (dis == "block") {
            setdis("none");
        }

    }

    const [loading, setLoading] = useState(true);
    const [filteritems, setfiltereditems] = useState("{}");
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            try {
                const body = {
                    token: Token.get(),
                    action: "get",
                };

                const response = await post(body, "/editGroups");

                if (!response) {
                    alert("FunktionenVerwaltung hat einen Fehler!");
                    return;
                }

                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }

                const json = JSON.parse(response);
                setdata(json);
                console.log(response);
                setfiltereditems(json.values);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        // Delay fetch slightly to avoid blocking render
        setTimeout(() => {
            fetchData();
        }, 0); 
    }, [navigate]);
    function search(e) {
        e.preventDefault();
        let prompt = document.getElementById("asöas2143asc3256z456").value;
        if (prompt == "") {
            setfiltereditems(data.values);
            return;
        }
        setfiltereditems(
            data.values.filter(item =>
                item.name && item.name.toLowerCase().includes(prompt.toLowerCase()) // Ensure desc is a string
            )
        );

    }
    const [wit, setwith] = useState("87.5%");
    const [createf, setcreatef] = useState(false);
    return (
        <>
            <head><title>Verwaltung || Funktionen Verwalten</title></head>
            <div><NavigationBar state="adminhome" back="inline" /></div>
            <div style={{ width: wit }} className='verwaltung-nutzer-container'>
                <div style={{
                    width: "95%",
                    backgroundColor: "#f7f7f7",
                    marginTop: "3.5%",
                    color: "white",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                    overflow: "visible"
                }}>
                    <div style={{
                        width: "100%",
                        height: "55px",
                        backgroundColor: "#2a3042",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        fontSize: "20px",
                    }}>
                        <p>Funktionen Verwaltung</p>
                    </div>
                    <div
                        style={{
                            padding: "10px", width: "100%",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                        }}>
                        <div style={{
                            backgroundColor: "transparent",
                            height: "60px",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "black", flexDirection: "row", justifyContent: "space-evenly"
                        }}>
                            <form style={{ display: "flex", marginLeft: "1%", width: "30%", backgroundColor: "transparent", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }} onSubmit={search}>
                                <div style={{ display: "flex", marginRight: "5%", width: "100%" }} class="group">
                                    <svg class="icon" aria-hidden="true" viewBox="0 0 24 24"><g><path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path></g></svg>
                                    <input onChange={e => {
                                        if (!document.getElementById("asöas2143asc3256z456").value) {
                                            setfiltereditems(data.values);
                                        }

                                    }} placeholder="Suchen" id="asöas2143asc3256z456" type="search" class="input" />

                                </div>
                            </form>
                            <Stylebutton buttonText={"Funktion Erstellen"} click={() => setcreatef(true)}></Stylebutton>
                        </div>

                        <div style={{
                            backgroundColor: "transparent",
                            width: "98%",
                            borderStyle: "solid",
                            borderColor: "black",
                            borderWidth: "1px",
                            borderColor: "lightgray",
                        }}>
                            <div style={{
                                width: "100%",
                                height: "40px",
                                backgroundColor: "white",
                                display: "flex",
                                color: "black",
                                fontSize: "15px",
                                alignItems: "center",
                                fontWeight: "bold",
                                borderBottom: "1px solid darkgray",
                            }}>
                                <p style={{ marginLeft: "1.5%" }}>Gruppen Informationen:</p>
                                <p style={{ marginLeft: "75%" }}>Bearbeiten:</p>
                            </div>

                            {loading ? (
                                <p>Loading groups...</p>
                            ) : filteritems === 0 ? (
                                <p style={{ marginLeft: "1%" }}>Keine Gruppe Gefunden</p>
                            ) : data.values.length > 0 ? (
                                <ul style={{ width: "100%", overflowY: "auto" }}>
                                    {filteritems
                                        .map((item, index) => (
                                            <li key={index} style={{ width: "100%" }}>
                                                <Group item={item}></Group>
                                            </li>
                                        ))}
                                </ul>
                            ) : (
                                <p>No User available</p>
                            )}

                        </div>
                    </div>


                </div>


            </div>
            {createf && (<CreateForm setmask={setcreatef} />)}
        </>
    );



}
export default GruppenVerwaltung;










